/*
 * @Author: Ashley.Liu
 * @Date: 2022-01-04 15:37:11
 * @LastEditTime: 2022-06-14 13:48:39
 * @Description: desc
 */
/* eslint-disable */
__webpack_public_path__ = resolve(window.domainFromServer, 'async_platform')
if (window.__POWERED_BY_QIANKUN__) {
  // eslint-disable-next-line camelcase,no-undef
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__
}
function resolve (a, b) {
  if (!a) {
    return ''
  }
  if (a[a.length - 1] === '/') {
    return a + b
  } else {
    return a + '/' + b
  }
}
 